// Импортируем другие js-файлы
jQuery(document).ready(function($){

	$('#navToggle').click(function() {
		$(this).toggleClass('active');
		$('.overlay').toggleClass('open');
		$('body').toggleClass('locked'); 
	});

	$('.newprod__slides').owlCarousel({
		items: 1,
		loop: true, // false удаляет клоны для правильной нумерации слайдов
		rewind: true,
		dots: false,
		nav: true,
		navText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>','<i class="fa fa-angle-right" aria-hidden="true"></i>'],
		mouseDrag: true,
		touchDrag: true,
		//center: true,
		//margin: 5,
		//stagePadding: 5,
		//autoplay: true,
		autoplayTimeout: 5000,
		autoplayHoverPause: true,
		responsive: {
			576: {
				items: 1
			},
			768: {
				items: 2
			},
			992: {
				items: 3
			},
			1200: {
				items: 4
			}
		}
	});

	$('.comment__slides').owlCarousel({
		items: 1,
		loop: true, // false удаляет клоны для правильной нумерации слайдов
		rewind: true,
		dots: true,
		nav: false,
		navText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>','<i class="fa fa-angle-right" aria-hidden="true"></i>'],
		mouseDrag: true,
		touchDrag: true,
		//center: true,
		//margin: 5,
		//stagePadding: 5,
		//autoplay: true,
		autoplayTimeout: 5000,
		autoplayHoverPause: true,
		responsive: {
			576: {
				items: 1
			},
			768: {
				items: 2
			},
			992: {
				items: 3
			},
			1200: {
				items: 3
			}
		}
	});

	$('.tabsmap__tab').on('click', function(e) {
		e.preventDefault();
		var n = $(this).index('.tabsmap__tab');
		$('.tabsmap__tab').removeClass('active_tab');
		$('.map').removeClass('active_map');
		$(this).addClass('active_tab');
		$('.map:eq(' + n + ')').addClass('active_map');
	});

	var headerFix = $('.header__fix').outerHeight();
	var headerMain = $('.header__main').outerHeight();
	$('body').css('margin-top', headerFix + 'px');
	$('.img-bg').css('top', '-' + headerFix + 'px').css('height', headerMain + headerFix + 'px')

	//footer bottom
	footer();
	$(window).resize(function() {
		footer();
	});
	function footer() {
		var docHeight = $(window).height(),
				docWidth = $(window).width(),
				footerHeight = $('.footer').outerHeight(),
				footerTop = $('.footer').position().top + footerHeight,
				main = $('.main').position().top
		if (footerTop < docHeight) {
			$('.main').css('height', (docHeight - main - footerHeight) +'px');
		}
	}

	$('.header__btnCall').click( function(event){
		event.preventDefault();
		$('#modoverlay').fadeIn(297, function(){
			$('#winmodal') 
			.css('display', 'block')
			.animate({opacity: 1}, 198);
		});
	});

	$('#winmodal__close, #modoverlay').click( function(){
		$('#winmodal').animate({opacity: 0}, 198, function(){
			$(this).css('display', 'none');
			$('#modoverlay').fadeOut(297);
		});
	});

});